export const windowType: string = "window";
export const windowStyle: string = "--top-margin: 40px; --height-max: calc(100vh - 156px); --height-f-max: calc(100vh - 70px);";

export const categoryConst: any = {
  headerFieds: [
    { type: 'text', label: 'Category Name', value: 'Category' },
    { type: 'text', label: 'Status', value: 'isActive' },
  ],
  searchParams: ['Category', 'isActive'],
};

export const productConst: any = {
  instrument: {
    headerFieds: [
      { type: 'text', label: 'Product Type', value: 'Product_type' },
      { type: 'text', label: 'Customer Name', value: 'Customer_Name' },
      { type: 'text', label: 'Hardware', value: 'Hardware' },
    ],
    fields: ['id', 'Product_type', 'Customer_Name', 'Hardware', 'Input', 'Model_no', 'Output', 'PCB_Port', 'Product_description'],
    searchParams: ['Product_type', 'Product_name', 'Model_no', 'Input', 'Output', 'PCB_Port', 'Hardware']
  },
  starter: {
    headerFieds: [
      { type: 'text', label: 'Model No', value: 'Model_no' },
      { type: 'text', label: 'Product Type', value: 'Product_type' },
      { type: 'text', label: 'Customer Name', value: 'Customer_Name' },
      { type: 'text', label: 'Relay/Contractor', value: 'relay' },
    ],
    fields: ['id', 'Product_type', 'Customer_Name', 'Hardware', 'Model_no', 'relay', 'Enclosure', 'PCB_Port', 'Product_description'],
    searchParams: ['Product_type', 'Product_name', 'Model_no', 'relay']
  }
};

export const transportConst: any = [
  { label: 'Transport Mode', value: '' },
  { label: 'Transport', value: 'Transport' },
  { label: 'Travels', value: 'Travels' },
  { label: 'Courier', value: 'Courier' },
  { label: 'By Hand', value: 'By Hand' },
  { label: 'Pickup', value: 'Pickup' },
];

export const statusConst: any = [
  { label: 'Status', value: '' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Sent', value: 'Sent' },
  { label: 'Approved', value: 'Approved' },
  { label: 'Rejected', value: 'Rejected' }
];

export const orderTypeConst: any = [
  { label: 'Order Type', value: '' },
  { label: 'NEW ORDER', value: 'New Order' },
  { label: 'REPEAT ORDER', value: 'Repeat Order' }
];

export const priorityConst: any = [
  { label: "High", value: "High" },
  { label: "Normal", value: "Normal" },
];

export const repairingStatusConst: any = [
  { label: "Pending", value: "Pending" },
  { label: "Working", value: "Working" },
  { label: "Ready", value: "Ready" },
  { label: "Completed", value: "Completed" }
];

export const repairingTypeConst: any = [
  { label: "Repair & Stock", value: "Repair & Stock" },
  { label: "Repair & Return", value: "Repair & Return" }
];

export const purchaseStatusConst: any = [
  { label: "Pending", value: "Pending" },
  { label: "Part Received", value: "Part" },
  { label: "Received", value: "Received" }
];

export const devStatusConst: any = [
  { label: "Pending", value: "Pending" },
  { label: "In Progress", value: "In Progress" },
  { label: "Completed", value: "Completed" }
];